export const GetFundColorClass = (type: string) => {
  if (type === "Rentefond") return "bg-[#398fe2] text-white";
  else if (type === "Aksjefond") return "bg-[#568E4B] text-white";
  return "bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark text-blueDark";
};
